import { useEffect, useRef } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { toast } from 'sonner';

const AuthCallback = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { exchangeSession } = useAuth();
  const hasProcessed = useRef(false);

  useEffect(() => {
    // Prevent double execution (React StrictMode)
    if (hasProcessed.current) return;
    hasProcessed.current = true;

    const processSession = async () => {
      try {
        // Extract session_id from URL fragment
        const hash = location.hash.substring(1); // Remove '#'
        const params = new URLSearchParams(hash);
        const sessionId = params.get('session_id');

        if (!sessionId) {
          toast.error('No session ID found');
          navigate('/login', { replace: true });
          return;
        }

        // Exchange session_id for session_token
        const data = await exchangeSession(sessionId);

        toast.success('Login successful!');

        // Division secretaries land on the portal; everyone else hits /dashboard.
        const dest = data?.user?.role === 'division_secretary' ? '/portal' : '/dashboard';
        navigate(dest, {
          replace: true,
          state: { user: data.user },
        });
      } catch (error) {
        console.error('Session exchange error:', error);
        toast.error(error.response?.data?.detail || 'Authentication failed');
        navigate('/login', { replace: true });
      }
    };

    processSession();
  }, [location.hash, exchangeSession, navigate]);

  return (
    <div className="flex items-center justify-center min-h-screen">
      <div className="text-center">
        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-primary mx-auto mb-4"></div>
        <p className="text-muted-foreground">Completing sign in...</p>
      </div>
    </div>
  );
};

export default AuthCallback;
